export default {
  // Chưa hạch toán
  NotAccounted: 0,

  // Không hạch toán
  NoAccounted: 1,

  // Đã hạch toán
  Accounted: 2,
};
